
import { Injectable } from '@angular/core';
import { ActionUpdaterService, ApiError } from './action-updater.service';
import { Http, Response, Jsonp } from '@angular/http';
import * as _ from 'lodash';
import { SectorOptions } from '../services/booking.service';
import { Booking, Totals, BookingManagementHeaders } from 'app/shared/models/booking.model';
import { StopItem } from '../services/reference-data.service';
import { Availability } from 'app/shared/models/availability.model';
import * as moment from 'moment';
import { InitialDataService, PassengerFareType } from 'app/initial-data.service';
import { Passengers, PassengerFormModel } from 'app/shared/models/passenger.model';
import { TimeTableTravelOptions, TravelOptions, AvailabilityOption } from 'app/shared/models/timetables.model';
import { ITINERARY_CONTEXT } from 'app/shared/models/enums/context.enum';
import { Dictionary } from '../models/dictonary.model';
import { FeatureService, Feature } from './feature.service';
declare function require(name: string): any;


export const LOCAL_STORAGE_KEYS = {
    OFFLINE_BOOKING: 'offline_booking',
    ONLINE_BOOKING: 'online_booking',
    CART: 'cart',
    TRAVEL_STOPS: 'travel_stops',
    TRANSLATION_CACHE: 'translation_cache',
    TIMETABLE_TRAVEL_OPTIONS: 'timetable_travel_options',
    TRAVEL_OPTIONS: 'travel_options',
    TRAVEL_AVAILABILITY: 'travel_availability',
    AVAILABILITY_EXTRAS: 'availability_extras',
    TRAVEL_PASSENGERS: 'travel_passengers',
    PACKAGE_TRAVEL_OPTIONS: 'package_travel_options',
    MUST_REDIRECT_NEW_BUS_TRAVEL: 'redirect',
    ADDED_TRIP_TO_BOOKING: 'added_trip_to_booking',
    BOOKING_MANAGEMENT_HEADERS: 'booking_management_headers',
    ERROR: 'error',
    SELECTED_TRAVEL: 'selectedTravel',
    TC_UPDATED: 'tc_updated',
    PROMO_CODE: 'promoCode'
};
@Injectable()
export class LocalStorageService {
    public currentAvailability: Array<Availability>;
    public currentAvailabilityOptions: AvailabilityOption;
    private appVersion = this.initialDataService.version;
    private repository: any;
    constructor(
        private actionUpdaterService: ActionUpdaterService,
        private initialDataService: InitialDataService,
        private featureService: FeatureService,
        private http: Http) {
        const storageAvailable = require('storage-available');
        const isStorageAvailable = storageAvailable('localStorage');
        if (isStorageAvailable) {
            this.repository = window.localStorage;
        }
    }

    applyPromoCode = (promoCode: string) => {
        this.repository.setItem(LOCAL_STORAGE_KEYS.PROMO_CODE, promoCode);
    }

    removePromoCode = () => {
        this.repository.removeItem(LOCAL_STORAGE_KEYS.PROMO_CODE);
    }

    hasPromoApplied = () => {
        try {
            let promoCode = this.repository.getItem(LOCAL_STORAGE_KEYS.PROMO_CODE);


            promoCode = !!promoCode ? promoCode : "";

            return promoCode;
        } catch (e) {
            return "";
        }
    }

    removeRedirect = () => {
        this.repository.removeItem(LOCAL_STORAGE_KEYS.MUST_REDIRECT_NEW_BUS_TRAVEL);
    }
    getRedirect = () => {
        try {
            let redirect = this.repository.getItem(LOCAL_STORAGE_KEYS.MUST_REDIRECT_NEW_BUS_TRAVEL);


            redirect = !!redirect ? redirect === 'true' : false;

            return redirect;
        } catch (e) {
            return false;
        }
    }
    saveRedirect = () => {
        this.repository.setItem(LOCAL_STORAGE_KEYS.MUST_REDIRECT_NEW_BUS_TRAVEL, true);
    }
    getPackageTravelOptions() {
        return JSON.parse(this.repository.getItem(LOCAL_STORAGE_KEYS.PACKAGE_TRAVEL_OPTIONS));
    }
    removePackageTravelOptions() {
        this.repository.removeItem(LOCAL_STORAGE_KEYS.PACKAGE_TRAVEL_OPTIONS);
    }
    removeTravelOptions(): void {
        this.repository.removeItem(LOCAL_STORAGE_KEYS.TIMETABLE_TRAVEL_OPTIONS);
    }
    saveTravelStops(stops) {
        this.repository.setItem(LOCAL_STORAGE_KEYS.TRAVEL_STOPS, JSON.stringify(stops));
    }
    getTravelStops() {
        return JSON.parse(this.repository.getItem(LOCAL_STORAGE_KEYS.TRAVEL_STOPS));
    }
    saveTranslation(key, value) {
        const translationCache = this.getTranslationCache();
        translationCache[key] = value;
        this.saveTranslationCache(translationCache);
    }
    getTranslationCache(): Dictionary<string> {
        let translationCache = JSON.parse(this.repository.getItem(LOCAL_STORAGE_KEYS.TRANSLATION_CACHE));
        // console.log('cache age:', moment(new Date()).diff(moment(translationCache['dictionaryCreationDate']), 'hours'));
        // console.log('maxCacheTime:', Number(this.featureService.GetFeatureValue(Feature.TranslationCacheTime)));
        // console.log('has cache expired?: ', moment(new Date()).diff(moment(translationCache['dictionaryCreationDate']), 'hours') > Number(this.featureService.GetFeatureValue(Feature.TranslationCacheTime)));
        if (translationCache == null ||
            translationCache['dictionaryCreationDate'] == null ||
            moment(new Date()).diff(moment(translationCache['dictionaryCreationDate']), 'hours') >= Number(this.featureService.GetFeatureValue(Feature.TranslationCacheTime))) {

            translationCache = new Dictionary<string>();
            translationCache['dictionaryCreationDate'] = new Date().toISOString();
        }

        return translationCache;
    }
    saveTranslationCache(translationDictionary: Dictionary<string>) {
        this.repository.setItem(LOCAL_STORAGE_KEYS.TRANSLATION_CACHE, JSON.stringify(translationDictionary));
    }
    removeTravelStops() {
        this.repository.removeItem(LOCAL_STORAGE_KEYS.TRAVEL_STOPS);
    }
    saveTravelPassengers(passengers: Passengers) {
        this.repository.setItem(LOCAL_STORAGE_KEYS.TRAVEL_PASSENGERS, JSON.stringify(passengers));
    }
    getTravelPassengers(): Passengers {
        return JSON.parse(this.repository.getItem(LOCAL_STORAGE_KEYS.TRAVEL_PASSENGERS)) as Passengers;
    }
    removeTravelPassengers() {
        this.repository.removeItem(LOCAL_STORAGE_KEYS.TRAVEL_PASSENGERS);
    }
    saveTimeTableTravelOptions(travelOptions: TimeTableTravelOptions) {
        this.repository.setItem(LOCAL_STORAGE_KEYS.TIMETABLE_TRAVEL_OPTIONS, JSON.stringify(travelOptions));
    }
    getTimeTableTravelOptions(): TimeTableTravelOptions {
        return JSON.parse(this.repository.getItem(LOCAL_STORAGE_KEYS.TIMETABLE_TRAVEL_OPTIONS));
    }
    saveTravelOptions(travelOptions: TravelOptions) {
        this.repository.setItem(LOCAL_STORAGE_KEYS.TRAVEL_OPTIONS, JSON.stringify(travelOptions));
    }
    getTravelOptions(): TravelOptions {
        return JSON.parse(this.repository.getItem(LOCAL_STORAGE_KEYS.TRAVEL_OPTIONS));
    }
    savePackageTravelOptions(options: AvailabilityOption, to: StopItem, from: StopItem) {
        const oldFormatForLegacyPurposes = {
            departureDate: options.TravelLegs[0].travelDate,
            from: from.Code,
            fromStop: from.Description,
            isReturn: options.isReturn,
            promoCode: options.TravelLegs[0].promotionCode,
            returnDate: options.isReturn ? options.TravelLegs[1].travelDate : null,
            to: to.Code,
            toStop: to.Description
        };

        this.repository.setItem(LOCAL_STORAGE_KEYS.PACKAGE_TRAVEL_OPTIONS, JSON.stringify(oldFormatForLegacyPurposes));
    }
    getOnlineBooking = () => {
        try {
            const booking = JSON.parse(this.repository.getItem(LOCAL_STORAGE_KEYS.ONLINE_BOOKING)) as Booking;

            if (!booking || this.isOutdatedVersion(booking)) {
                return null;
            }
            return booking;
        } catch (e) {
            return null;
        }
    }
    saveOnlineBooking = (booking: Booking) => {
        if (!!booking) {
            this.stampVersionNumber(booking);
            this.repository.setItem(LOCAL_STORAGE_KEYS.ONLINE_BOOKING, JSON.stringify(booking));
        }
    }
    saveOfflineBooking(booking: Booking) {
        /* this.stampVersionNumber(booking); */ // TODO check
        this.repository.setItem(LOCAL_STORAGE_KEYS.OFFLINE_BOOKING, JSON.stringify(booking));
    }
    resetOfflineBooking = () => {
        this.saveOfflineBooking(new Booking());
    }
    getOfflineBooking(): Booking {
        try {
            const booking: Booking = JSON.parse(this.repository.getItem(LOCAL_STORAGE_KEYS.OFFLINE_BOOKING));

            if (!booking/*  || this.isOutdatedVersion(booking) */) { // TODO check
                return new Booking();
            }
            return booking;
        } catch (e) {
            return new Booking();
        }
    }
    saveTravelAvailability(availabilities: Array<Availability>) {
        this.repository.setItem(LOCAL_STORAGE_KEYS.TRAVEL_AVAILABILITY, JSON.stringify(availabilities));
    }
    getTravelAvailability(): Availability[] {
        const availability = JSON.parse(this.repository.getItem(LOCAL_STORAGE_KEYS.TRAVEL_AVAILABILITY));
        try {
            // if (!!availability && this.isOutdatedVersion(availability)) {
            //     return new Core.TravelAvailability();
            // }
            return availability;

        } catch (e) {
            return [];
        }
    }
    saveAvailabilityExtras(extras: AvailabilityExtras): void {
        this.repository.setItem(LOCAL_STORAGE_KEYS.AVAILABILITY_EXTRAS, JSON.stringify(extras));
    }
    getAvailabilityExtras(): AvailabilityExtras {
        return JSON.parse(this.repository.getItem(LOCAL_STORAGE_KEYS.AVAILABILITY_EXTRAS));
    }
    removeAvailabilityExtras(): void {
        this.repository.removeItem(LOCAL_STORAGE_KEYS.AVAILABILITY_EXTRAS);
    }
    addTravelToBooking(options): void {
        if (!options.legName ||
            !options.travelGuid ||
            !options.routeNumber ||
            !options.fareGuid) {
            throw new Error('could not add travel to booking. Some options are missing.');
        }

        const booking: Booking = this.getOfflineBooking()
        if (!booking.travels) {
            booking.travels = [];
        }
        const availability = this.getTravelAvailability(),
            travelAvailability: any = availability.find(a => a.TravelGUID === options.travelGuid),
            routeOption: any = travelAvailability.RouteOptions.find(ro => ro.RouteNumber === options.routeNumber),
            fare = routeOption.Fares.find(ro => ro.FareGUID === options.fareGuid),
            existingTravelLegIdx = booking.travels.findIndex((tr: any) => tr.TravelLegName === options.legName);



        // Create new object relationship for:
        // TravelAvailability > RouteOptions > Fares
        // this contains only the chosen RouteOptions and Fare. (eliminates other routes/fares)
        routeOption.Fares = [fare];
        travelAvailability.RouteOptions = [routeOption];
        travelAvailability.TravelLegName = options.legName;

        // ADD TRAVEL LEG TO BOOKING
        // is there any existing travel with the same legName?
        // if so, replace it with the new one
        if (existingTravelLegIdx > -1) {
            booking.travels.splice(existingTravelLegIdx, 1, travelAvailability);
        } else {
            booking.travels.push(travelAvailability);
        }

        // save booking
        this.saveOfflineBooking(booking);
    }
    getCart = () => {
        try {
            const cart = JSON.parse(this.repository.getItem(LOCAL_STORAGE_KEYS.CART)) as Totals;
            return !!cart ? cart : null;
        } catch (e) {
            return null;
        }
    }
    saveCart = (cart: Totals) => {
        if (!!cart) {
            this.repository.setItem(LOCAL_STORAGE_KEYS.CART, JSON.stringify(cart));
        }
    }

    addPassengerToOfflineBooking = (passengerDetails: PassengerFormModel) => {
        const booking = this.getOfflineBooking();
        booking.passengerDetails = passengerDetails;
        this.saveOfflineBooking(booking);
    }
    resetManagedBooking = () => {
        this.saveCart(new Totals());
        this.saveOnlineBooking(new Booking());
    }
    setAddedTripToBooking = (isAdded: boolean) => {
        if (isAdded) {
            this.repository.setItem(LOCAL_STORAGE_KEYS.ADDED_TRIP_TO_BOOKING, isAdded);
        } else {
            this.repository.removeItem(LOCAL_STORAGE_KEYS.ADDED_TRIP_TO_BOOKING);
        }
    }
    hasTripBeenAdded = () => {
        return !!this.repository.getItem(LOCAL_STORAGE_KEYS.ADDED_TRIP_TO_BOOKING);
    }
    saveError = (jsonError: ApiError) => {
        if (jsonError === null) {
            this.repository.removeItem(LOCAL_STORAGE_KEYS.ERROR);
        } else {
            this.repository.setItem(LOCAL_STORAGE_KEYS.ERROR, JSON.stringify(jsonError));
        }

    }
    hasBeenAnError = (): boolean => {
        return !!this.repository.getItem(LOCAL_STORAGE_KEYS.ERROR);
    }
    getError = (): ApiError => {
        return JSON.parse(this.repository.getItem(LOCAL_STORAGE_KEYS.ERROR));
    }
    getBookingManagementHeadersState = () => {
        return JSON.parse(this.repository.getItem(LOCAL_STORAGE_KEYS.BOOKING_MANAGEMENT_HEADERS)) as BookingManagementHeaders;
    }
    saveBookingManagementHeadersState = (headers: BookingManagementHeaders) => {
        if (!!headers) {
            this.repository.setItem(LOCAL_STORAGE_KEYS.BOOKING_MANAGEMENT_HEADERS, JSON.stringify(headers));
        }
    }
    addPromocodeToOfflineBooking = (promocode: string, promocodeDescription: string) => {
        const booking = this.getOfflineBooking();
        booking.promocode = promocode;
        booking.promocodeDescription = promocodeDescription;
        this.saveOfflineBooking(booking);
    }
    removePromocodeFromOfflineBooking = () => {
        const booking = this.getOfflineBooking();
        booking.promocode = null;
        booking.promocodeDescription = null;
        this.saveOfflineBooking(booking);
    }
    setSelectedTravelFromBooking(bookingGuid: string, selectedSectors: Array<SectorOptions>) {
        const json = this.repository.getItem(LOCAL_STORAGE_KEYS.SELECTED_TRAVEL);
        let selecteSectorsWrapperArr: SelecteSectorsWrapper[];
        let selecteSectorsWrapper: SelecteSectorsWrapper;
        if (!!json) {
            selecteSectorsWrapperArr = JSON.parse(json);
            selecteSectorsWrapper = selecteSectorsWrapperArr.find(arr => arr.bookingGuid === bookingGuid);
            if (!!selecteSectorsWrapper) {
                selecteSectorsWrapper.selectedSectors = selectedSectors;
            } else {
                selecteSectorsWrapper = new SelecteSectorsWrapper();
                selecteSectorsWrapper.bookingGuid = bookingGuid;
                selecteSectorsWrapper.selectedSectors = selectedSectors;
                selecteSectorsWrapperArr.push(selecteSectorsWrapper);
            }
        } else {
            selecteSectorsWrapper = new SelecteSectorsWrapper();
            selecteSectorsWrapper.bookingGuid = bookingGuid;
            selecteSectorsWrapper.selectedSectors = selectedSectors;
            selecteSectorsWrapperArr = [selecteSectorsWrapper];
        }
        this.repository.setItem(LOCAL_STORAGE_KEYS.SELECTED_TRAVEL, JSON.stringify(selecteSectorsWrapperArr));
    }
    getSelectedTravelFromBooking(bookingGuid: string): Array<SectorOptions> | null {
        let sectors: Array<SectorOptions> = [];
        const json = this.repository.getItem(LOCAL_STORAGE_KEYS.SELECTED_TRAVEL);
        let selecteSectorsWrapperArr: SelecteSectorsWrapper[];
        let selecteSectorsWrapper: SelecteSectorsWrapper;
        if (!!json) {
            selecteSectorsWrapperArr = JSON.parse(json);
            selecteSectorsWrapper = selecteSectorsWrapperArr.find(arr => arr.bookingGuid === bookingGuid);
            if (!!selecteSectorsWrapper) {
                sectors = selecteSectorsWrapper.selectedSectors;
            }
        }
        return sectors;
    }
    removeSelectedTravelFromBooking(bookingGuid: string): void {
        const json = this.repository.getItem(LOCAL_STORAGE_KEYS.SELECTED_TRAVEL);
        let selecteSectorsWrapperArr: SelecteSectorsWrapper[];
        if (!!json) {
            selecteSectorsWrapperArr = JSON.parse(json);
            selecteSectorsWrapperArr = selecteSectorsWrapperArr.filter(arr => arr.bookingGuid !== bookingGuid);
        }
        this.repository.setItem(LOCAL_STORAGE_KEYS.SELECTED_TRAVEL, JSON.stringify(selecteSectorsWrapperArr));
    }

    getIfTCUpdated(customerGuid: string) {
        const tcUpdatedDictionary = this.repository.getItem(LOCAL_STORAGE_KEYS.TC_UPDATED);
        if (tcUpdatedDictionary == null) {
            return 'false';
        }
        return JSON.parse(this.repository.getItem(LOCAL_STORAGE_KEYS.TC_UPDATED))[customerGuid];
    }

    setIfTCUpdated(customerGuid: string, value: boolean) {
        let tcUpdatedDictionary = new Dictionary<string>();
        if (this.repository.getItem(LOCAL_STORAGE_KEYS.TC_UPDATED) != null) {
            tcUpdatedDictionary = JSON.parse(this.repository.getItem(LOCAL_STORAGE_KEYS.TC_UPDATED));
        }

        tcUpdatedDictionary[customerGuid] = value.toString();
        this.repository.setItem(LOCAL_STORAGE_KEYS.TC_UPDATED, JSON.stringify(tcUpdatedDictionary));
    }

    removeIfTCUpdated() {
        this.repository.removeItem(LOCAL_STORAGE_KEYS.TC_UPDATED);
    }

    // Input format from API is '21/09/2017 7:30:00 AM'
    public getJsDate(stringDate: string, format: string) {
        const jsDate = moment(stringDate, format).toDate();
        return jsDate;
    }

    private isOutdatedVersion = (obj) => {
        return !obj || obj._version !== this.appVersion;
    }

    private stampVersionNumber = (obj) => {
        obj._version = this.appVersion;
    }
}
export class SelecteSectorsWrapper {
    public bookingGuid: string;
    public selectedSectors: Array<SectorOptions>;
}
export class AvailabilityExtras {
    public bookingGuid: string;
    public productReference: string;
    public isReturn: boolean;
    public sector: number;
    public context: ITINERARY_CONTEXT;
}



// WEBPACK FOOTER //
// ./src/app/shared/services/local-storage.service.ts